module.exports = __webpack_public_path__ + "static/media/join-team.9ea288d4.png";